import { PillSelector } from "@monsterindia/global-ui-components";
import { memo } from "react";
import { Controller } from "react-hook-form";

import { DropdownOptionType } from "../../../types/dropdownOption";
import { ErrorText } from "../../apop/common/ErrorText";
import { PillControllerProps } from "./pillController.types";

const PillController = ({
  name,
  control,
  options,
  onSelect,
  size,
  selectType,
  isRequired = true,
  errorMessage,
}: PillControllerProps) => {
  return (
    <Controller
      name={name}
      control={control}
      rules={isRequired ? { required: "This field is required" } : undefined}
      render={() => {
        return (
          <>
            <PillSelector
              id={name}
              selectType={selectType}
              options={options}
              size={size}
              getValue={(selected: DropdownOptionType[]) => {
                onSelect(selected);
              }}
            />
            {errorMessage ? <ErrorText text={errorMessage} /> : null}
          </>
        );
      }}
    />
  );
};

export default memo(PillController);
